(function(){
"use strict";

var PHOTO1=(window.BB_ASSETS||{}).photo1||"";
var PHOTO2=(window.BB_ASSETS||{}).photo2||"";

/* ---------- data ---------- */
var P=[
 {id:"rio",name:"Rio de Janeiro",coords:"22.91\u00B0 S / 43.17\u00B0 W",cat:"For him",price:30,wash:"#F0EBD2",
  family:"Citrus Amber Woody",
  plain:"The citrus one \u2014 bright, zesty, uplifting",
  top:"Bergamot, citrus peel, mandarin, orange",heart:"Tropical fruits, aromatic woods, soft florals",base:"Amber, tonka, vanilla, smooth woods, musk",
  longTxt:"7\u20139 hrs",longPct:74,projTxt:"Moderate",projPct:64,rev:22,
  occ:["Daytime","Summer","Holidays"],
  desc:"A bright, energetic citrus inspired by sun-drenched coastlines. Sparkling freshness opens uplifting and vibrant; smooth tropical woods add depth while tonka and amber warm the dry-down \u2014 fresh brightness with a luxurious sweet-woody finish.",
  story:"Rio is the window-down, sun-on-your-face scent \u2014 the one that turns an ordinary Tuesday into a holiday. Spray it and walk out lighter."},
 {id:"milano",name:"Milano",coords:"45.46\u00B0 N / 9.19\u00B0 E",cat:"For him",price:30,wash:"#EEF0E6",
  family:"Fresh Fruity Aromatic \u00B7 Clean Luxury",
  plain:"The clean one \u2014 fresh, everyday, polished",
  top:"Fresh citrus, crisp fruits, bergamot, green accords",heart:"Juicy tropical fruits, smooth florals, clean aromatics",base:"Amber, musk, light woods, subtle vanilla",
  longTxt:"8\u201310 hrs",longPct:80,projTxt:"Moderate\u2013strong",projPct:70,rev:26,
  occ:["Every day","The office","Your signature"],
  desc:"A refined everyday fragrance built on freshness and effortless confidence. Clean citrus and fruity accords open bright before a smooth, modern aromatic heart; soft woods, amber and musk leave a polished signature that never overpowers.",
  story:"Milano is the one you reach for without thinking \u2014 the scent that makes you smell clean, expensive and put together before you have said a word. Your everyday armour."},
 {id:"paname",name:"Paname",coords:"48.86\u00B0 N / 2.35\u00B0 E",cat:"For her",price:30,wash:"#F1E8DC",
  family:"Amber \u00B7 Sweet Vanilla Oriental",
  plain:"The vanilla one \u2014 warm, sweet, indulgent",
  top:"Warm vanilla, soft amber, light fruit, golden caramel",heart:"Rich vanilla, creamy florals, benzoin, sweet resins",base:"Brown sugar, tonka, amber, soft musk, warm woods",
  longTxt:"10\u201312 hrs",longPct:90,projTxt:"Strong",projPct:80,rev:24,
  occ:["Date night","Cold evenings","Cosy nights in"],
  desc:"A luxurious vanilla amber built on warmth and sweetness. A smooth golden opening melts into a rich, creamy vanilla heart \u2014 like melted amber, soft spices and freshly made vanilla. Comforting, indulgent and undeniably luxurious.",
  story:"Paname is the scent you wear close \u2014 warm vanilla that wraps around you like cashmere. Made for slow evenings and the people you let get close enough to notice."},
 {id:"havana",name:"Havana",coords:"23.11\u00B0 N / 82.36\u00B0 W",cat:"For her",price:30,wash:"#F3E7E6",
  family:"Fruity Gourmand \u00B7 Sweet Floral Amber",
  plain:"The fruity one \u2014 juicy berries, soft florals",
  top:"Juicy berries, sweet fruits, soft citrus, creamy fruit",heart:"Floral sweetness, strawberry, soft vanilla, delicate florals",base:"Vanilla, amber, musk, soft woods, warm sweetness",
  longTxt:"8\u201310 hrs",longPct:82,projTxt:"Strong",projPct:76,rev:19,
  occ:["Nights out","Spring days","Celebrations"],
  desc:"A playful yet luxurious fruity gourmand that captures a tropical sunset. Juicy, vibrant fruits burst open before melting into a soft floral heart wrapped in creamy vanilla sweetness \u2014 flirtatious, feminine and impossible to ignore.",
  story:"Havana is the flirt of the collection \u2014 juicy, sweet and made to be asked about. Wear it on the nights you want to be remembered, and let the compliments come to you."},
 {id:"monaco",name:"Monaco",coords:"43.73\u00B0 N / 7.42\u00B0 E",cat:"The Reserve",price:40,wash:"#E7DFD0",badge:"The Oud",
  family:"Amber Woody Gourmand \u00B7 Oud Vanilla",
  plain:"The oud one \u2014 creamy vanilla, dark woods",
  top:"Warm vanilla, soft spices, sweet amber, golden sweetness",heart:"Rich oud, creamy vanilla orchid, benzoin warmth, woody depth",base:"Dark oud wood, tonka, brown sugar, amber, soft musk",
  longTxt:"12+ hrs",longPct:97,projTxt:"Very strong",projPct:92,rev:33,
  occ:["Black tie","Winter nights","High stakes"],
  desc:"A luxurious fusion of creamy vanilla and deep oriental woods \u2014 the crown of the Reserve. A rich, addictive sweetness opens before a sophisticated oud heart brings depth and mystery, finishing on a sensual trail of dark oud wrapped in velvety vanilla. A private-collection feel.",
  story:"Monaco is for the nights when the stakes are high and you intend to win. Dark oud, golden vanilla, and confidence that enters the room a step before you do. Crafted for depth, priced at \u00A340 for a reason."},
 {id:"casablanca",name:"Casablanca",coords:"33.57\u00B0 N / 7.59\u00B0 W",cat:"The Reserve",price:30,wash:"#EFE5D2",badge:"Reserve",
  family:"Amber Gourmand",
  plain:"The gourmand one \u2014 cake, spice, golden vanilla",
  top:"Sparkling mandarin, sweet bergamot, lavender, cardamom",heart:"Warm cinnamon, benzoin, creamy orange blossom, caramel",base:"Vanilla bean, tonka, amber, sandalwood, smooth musk",
  longTxt:"10\u201312 hrs",longPct:92,projTxt:"Strong",projPct:84,rev:29,
  occ:["Dinner dates","Cold evenings","Compliments"],
  desc:"An indulgent amber gourmand that opens with a vibrant burst of citrus before unfolding into warm spice and golden sweetness. Creamy vanilla, rich tonka and smooth amber build a cake-like warmth that feels comforting yet sophisticated \u2014 a soft, addictive, long-lasting trail.",
  story:"Casablanca is the compliment magnet of the house \u2014 warm sponge, golden spice and praline you can wear. Save it for long dinners and cold evenings, then get used to strangers asking what it is."}
];
var PAIRS={rio:"milano",milano:"rio",paname:"havana",havana:"paname",monaco:"casablanca",casablanca:"monaco"};
function byId(id){for(var i=0;i<P.length;i++){if(P[i].id===id)return P[i];}return P[0];}
function money(n){return "£"+n.toFixed(2);}

/* ---------- svg builders (official bottle) ---------- */
var UID=0;
function bottleSVG(cls){
 UID++;var g="g"+UID,t="t"+UID,x="x"+UID;
 var s='<svg class="'+(cls||"bottle")+'" viewBox="0 0 200 340" role="img" aria-label="BuiltByThree bottle">';
 s+='<defs>';
 s+='<linearGradient id="'+g+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#EFCF7F"/><stop offset=".5" stop-color="#C69A44"/><stop offset="1" stop-color="#8F6B25"/></linearGradient>';
 s+='<linearGradient id="'+x+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#0A0908"/><stop offset=".42" stop-color="#0F0D0B"/><stop offset=".62" stop-color="#161310"/><stop offset=".78" stop-color="#241E18" stop-opacity=".85"/><stop offset=".9" stop-color="#B9B2A4" stop-opacity=".22"/><stop offset="1" stop-color="#E4DFD2" stop-opacity=".14"/></linearGradient>';
 s+='<pattern id="'+t+'" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="6" height="6" fill="#15120F"/><line x1="0" y1="0" x2="0" y2="6" stroke="rgba(201,178,131,.16)" stroke-width="1.1"/></pattern>';
 s+='</defs>';
 s+='<rect x="64" y="6" width="72" height="8" rx="3" fill="url(#'+g+')"/>';
 s+='<rect x="64" y="14" width="72" height="46" fill="url(#'+t+')" stroke="rgba(0,0,0,.45)"/>';
 s+='<rect x="64" y="60" width="72" height="9" fill="url(#'+g+')"/>';
 s+='<rect x="74" y="69" width="52" height="13" fill="url(#'+g+')" opacity=".92"/>';
 s+='<path d="M66 84 H134 L154 104 V300 L140 318 H60 L46 300 V104 Z" fill="url(#'+x+')" stroke="rgba(255,255,255,.07)"/>';
 s+='<path d="M52 288 H148 L140 312 H60 Z" fill="rgba(240,236,226,.12)"/>';
 s+='<rect x="52" y="104" width="7" height="172" rx="3.5" fill="rgba(255,255,255,.13)"/>';
 s+='<rect x="141" y="112" width="4" height="150" rx="2" fill="rgba(255,255,255,.07)"/>';
 s+='<g fill="url(#'+g+')"><g transform="scale(-1,1)"><text x="-91" y="176" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="46" letter-spacing="0">B</text></g><text x="109" y="176" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="46" letter-spacing="0">B</text></g>';
 s+='<text x="100" y="252" text-anchor="middle" font-family="Marcellus,serif" font-size="10.5" letter-spacing=".6" fill="url(#'+g+')">Extrait de Parfum</text>';
 s+='</svg>';
 return s;
}
function boxSVG(p){
 UID++;var g="g"+UID;
 var s='<svg class="boxart" viewBox="0 0 200 320" role="img" aria-label="'+p.name+' presentation box">';
 s+='<defs><linearGradient id="'+g+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#EFCF7F"/><stop offset=".5" stop-color="#C69A44"/><stop offset="1" stop-color="#8F6B25"/></linearGradient></defs>';
 s+='<rect x="36" y="28" width="128" height="264" rx="4" fill="#101218"/>';
 s+='<rect x="36" y="28" width="10" height="264" rx="4" fill="#1A1D26"/>';
 s+='<g fill="url(#'+g+')"><g transform="scale(-1,1)"><text x="-93" y="120" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="34">B</text></g><text x="107" y="120" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="34">B</text></g>';
 s+='<text x="100" y="146" text-anchor="middle" font-family="Marcellus,serif" font-size="13" letter-spacing=".5" fill="url(#'+g+')">BuiltByThree</text>';
 s+='<text x="100" y="250" text-anchor="middle" font-family="Marcellus,serif" font-size="10" fill="url(#'+g+')">Extrait</text>';
 s+='<text x="100" y="266" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-size="8" letter-spacing="1" fill="#B8B0A0">50 ml · '+p.name.toUpperCase()+'</text>';
 s+='</svg>';
 return s;
}
function detailSVG(p){
 UID++;var g="g"+UID;
 var s='<svg viewBox="0 0 200 320" role="img" aria-label="'+p.name+' details">';
 s+='<defs><linearGradient id="'+g+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#D9B15F"/><stop offset="1" stop-color="#9A7530"/></linearGradient></defs>';
 s+='<rect x="0" y="0" width="200" height="320" fill="#F8F6F0"/>';
 s+='<rect x="16" y="16" width="168" height="288" fill="none" stroke="#A0824A" stroke-width="1"/>';
 s+='<g fill="url(#'+g+')"><g transform="scale(-1,1)"><text x="-88" y="140" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="52">B</text></g><text x="112" y="140" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="52">B</text></g>';
 s+='<text x="100" y="176" text-anchor="middle" font-family="Marcellus,serif" font-size="15" letter-spacing="2" fill="#15130F">'+p.name.toUpperCase()+'</text>';
 s+='<text x="100" y="198" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-size="8.5" letter-spacing="2.5" fill="#5E5749">'+p.coords.toUpperCase()+'</text>';
 s+='<text x="100" y="224" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-size="7" letter-spacing="1.6" fill="#877F71">EXTRAIT STRENGTH</text>';
 s+='<text x="100" y="238" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-size="7" letter-spacing="1.6" fill="#877F71">MACERATED TO PERFECTION</text>';
 s+='</svg>';
 return s;
}

/* ---------- state ---------- */
var cart={},wish={},recent=[],qty=1,current=null,drawerMode="cart",curFilter="all",galArr=[];

function $(s){return document.querySelector(s);}
function $all(s){return document.querySelectorAll(s);}

/* ---------- cards ---------- */
function cardHTML(p){
 var h='<article class="card reveal in" data-card="'+p.id+'">';
 h+='<button class="iconbtn wish'+(wish[p.id]?" on":"")+'" data-wish="'+p.id+'" aria-label="Toggle wishlist for '+p.name+'"><svg viewBox="0 0 24 24"><path d="M12 20s-7-4.5-9.2-8.6C1.2 8.4 3 5 6.4 5c2 0 3.6 1.1 4.6 2.7h2C14 6.1 15.6 5 17.6 5 21 5 22.8 8.4 21.2 11.4 19 15.5 12 20 12 20Z"/></svg></button>';
 if(p.badge){h+='<span class="badge">'+p.badge+'</span>';}
 h+='<a class="card-media" href="#" data-open="'+p.id+'" style="--wash:'+p.wash+'">'+bottleSVG()+'</a>';
 h+='<div class="card-body"><p class="coords">'+p.coords+'</p>';
 h+='<h3 class="card-name"><a href="#" data-open="'+p.id+'">'+p.name+'</a></h3>';
 h+='<p class="fam">'+p.plain+'</p>';
 h+='<div class="chips"><span class="chip">'+p.cat+'</span><span class="chip">'+p.occ[0]+'</span></div>';
 h+='<div class="card-row"><span class="price">'+money(p.price)+'</span><button class="btn btn-sm" data-add="'+p.id+'">Add to cart</button></div>';
 h+='</div></article>';
 return h;
}
function renderGrid(el,list){var h="";for(var i=0;i<list.length;i++){h+=cardHTML(list[i]);}el.innerHTML=h;}
function applyFilter(f){
 curFilter=f;
 $all("#pills .pill").forEach(function(b){b.classList.toggle("on",b.getAttribute("data-filter")===f);});
 renderGrid($("#prodGrid"),P.filter(function(p){return f==="all"||p.cat===f;}));
}

/* ---------- initial paint ---------- */
applyFilter("all");
$("#heroPhoto").src = (window.BB_ASSETS || {}).heroNew || PHOTO1;
$("#giftPhoto").src = (window.BB_ASSETS || {}).giftNew || PHOTO2;
$("#tileBottle").innerHTML=bottleSVG();

var mq="",i;
var mqItems=["A NEW ERA OF FRAGRANCE","LEAVE A TRACE"];
for(i=0;i<P.length;i++){mqItems.push(P[i].name.toUpperCase()+" — "+P[i].coords);}
for(var r=0;r<2;r++){for(i=0;i<mqItems.length;i++){mq+='<span><i>✦</i>'+mqItems[i]+'</span>';}}
$("#mqTrack").innerHTML=mq;

var megaH="",footH="";
for(i=0;i<P.length;i++){
 megaH+='<a href="#" data-open="'+P[i].id+'">'+P[i].name+'<span>'+money(P[i].price)+'</span></a>';
 footH+='<a href="#" data-open="'+P[i].id+'">'+P[i].name+'</a>';
}
$("#megaList").innerHTML=megaH;
$("#footShop").innerHTML=footH;

/* announcement rotation */
var annMsgs=[
 '<b>Launch giveaway</b> — 10 × 50ml bottles, plus £500 &amp; £200 cash prizes. <a href="#join" data-goto="join">Enter free</a>',
 '<b>Free UK delivery</b> on orders over £50 · Crafted for lasting presence',
 '<b>The Reserve</b> — Monaco &amp; Casablanca. <a href="#best" data-cat="The Reserve">Explore</a>'
];
var annI=0,annEl=$("#annMsg");
if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches){
 setInterval(function(){
  annEl.style.opacity=0;
  setTimeout(function(){annI=(annI+1)%annMsgs.length;annEl.innerHTML=annMsgs[annI];annEl.style.opacity=1;},420);
 },6000);
}

/* ---------- toast ---------- */
var toastT;
function toast(msg){var t=$("#toast");t.textContent=msg;t.classList.add("on");clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove("on");},2600);}

/* ---------- drawers ---------- */
function openScrim(){$("#scrim").classList.add("on");document.body.style.overflow="hidden";}
function closeAll(){
 $("#scrim").classList.remove("on");
 $("#drawer").classList.remove("on");
 $("#mnav").classList.remove("on");
 $("#search").classList.remove("on");
 document.body.style.overflow="";
}
function openDrawer(mode){
 drawerMode=mode||"cart";
 $("#drTitle").textContent=drawerMode==="cart"?"Your cart":"Your wishlist";
 $("#drFoot").style.display=drawerMode==="cart"?"block":"none";
 renderDrawer();
 $("#drawer").classList.add("on");openScrim();
}
function cartCountN(){var n=0;for(var k in cart){n+=cart[k];}return n;}
function cartTotal(){var t=0;for(var k in cart){t+=byId(k).price*cart[k];}return t;}
function renderBadges(){
 var c=cartCountN(),cc=$("#cartCount");cc.textContent=c;cc.classList.toggle("hide",c===0);
 var w=0;for(var k in wish){if(wish[k])w++;}
 var wc=$("#wishCount");wc.textContent=w;wc.classList.toggle("hide",w===0);
}
function renderDrawer(){
 var body=$("#drBody"),h="";
 if(drawerMode==="cart"){
  var any=false;
  for(var k in cart){
   any=true;var p=byId(k);
   h+='<div class="line">'+bottleSVG();
   h+='<div><div class="l-name">'+p.name+'</div><div class="l-sub">50 ml · Extrait</div>';
   h+='<span class="qty"><button data-qminus="'+k+'" aria-label="Decrease">−</button><output>'+cart[k]+'</output><button data-qplus="'+k+'" aria-label="Increase">+</button></span></div>';
   h+='<div class="l-end"><span class="price">'+money(p.price*cart[k])+'</span><br><button class="rm" data-remove="'+k+'">Remove</button></div></div>';
  }
  if(!any){h='<div class="empty">Your cart is empty.<br><br><a class="link-line" href="#best" data-goto="best">Shop the City Series</a></div>';}
  body.innerHTML=h;
  var st=cartTotal();
  $("#subTotal").textContent=money(st);
  var pct=Math.min(100,st/50*100);
  $("#shipBar").style.width=pct+"%";
  $("#shipLbl").textContent=st>=50?"Free UK delivery unlocked ✦":(st===0?"Free UK delivery over £50":"Add "+money(50-st)+" more for free UK delivery");
  $("#checkoutBtn").disabled=st===0;
 }else{
  var anyw=false;
  for(var w in wish){
   if(!wish[w])continue;anyw=true;var pw=byId(w);
   h+='<div class="line">'+bottleSVG();
   h+='<div><div class="l-name">'+pw.name+'</div><div class="l-sub">'+pw.plain+'</div></div>';
   h+='<div class="l-end"><span class="price">'+money(pw.price)+'</span><br><button class="rm" data-add="'+w+'">Add to cart</button></div></div>';
  }
  if(!anyw){h='<div class="empty">Nothing saved yet.<br>Tap the heart on any fragrance.</div>';}
  body.innerHTML=h;
 }
}
function addToCart(id,q){
 q=q||1;cart[id]=(cart[id]||0)+q;
 renderBadges();openDrawer("cart");
 toast(byId(id).name+" added to cart");
}

/* ---------- scent finder ---------- */
var fState=null;
function fRender(){
 var box=$("#finderBox"),h="";
 if(!fState){
  h+='<p class="f-step">Question 01 / 02</p><h3 class="f-q">Who is it for?</h3>';
  h+='<div class="f-opts">';
  h+='<button class="f-opt" data-f1="For him">For him<em>Rio de Janeiro or Milano</em></button>';
  h+='<button class="f-opt" data-f1="For her">For her<em>Paname or Havana</em></button>';
  h+='<button class="f-opt" data-f1="The Reserve">Go all out<em>The Reserve: Monaco or Casablanca</em></button>';
  h+='</div>';
 }else if(!fState.pick){
  var o=[];
  if(fState.cat==="For him"){o=[["rio","Bright citrus","Zesty, fresh, uplifting"],["milano","Clean everyday","Fresh, polished, all day"]];}
  else if(fState.cat==="For her"){o=[["paname","Warm vanilla","Sweet, creamy, indulgent"],["havana","Juicy fruits","Berries, playful, floral"]];}
  else{o=[["monaco","Deep oud","Dark, powerful, £40"],["casablanca","Cake gourmand","Warm, golden, sweet"]];}
  h+='<p class="f-step">Question 02 / 02</p><h3 class="f-q">Pick your mood.</h3><div class="f-opts">';
  for(var i=0;i<o.length;i++){h+='<button class="f-opt" data-f2="'+o[i][0]+'">'+o[i][1]+'<em>'+o[i][2]+'</em></button>';}
  h+='</div><button class="f-back" data-fback>← Back</button>';
 }else{
  var p=byId(fState.pick);
  h+='<p class="f-step">Your city</p>';
  h+='<div class="f-res">'+bottleSVG();
  h+='<div><p class="coords">'+p.coords+'</p><h3>'+p.name+'</h3><p class="fam">'+p.plain+'</p>';
  h+='<span class="price">'+money(p.price)+'</span>';
  h+='<div class="row"><button class="btn btn-inv" data-add="'+p.id+'">Add to cart</button><button class="btn btn-ghost" data-open="'+p.id+'">View '+p.name+'</button></div>';
  h+='</div></div><button class="f-back" data-fback>← Start again</button>';
 }
 box.innerHTML=h;
}
fRender();

/* ---------- product page ---------- */
function openProduct(id){
 var p=byId(id);current=p;qty=1;$("#qOut").textContent="1";
 $("#crumbCat").textContent=p.cat;
 $("#crumbName").textContent=p.name;
 $("#pCoords").textContent=p.coords;
 $("#pName").textContent=p.name;
 $("#pFamily").textContent=p.family;
 $("#pFam").textContent=p.plain;
 $("#pChips").innerHTML='<span class="chip">'+p.cat+'</span><span class="chip">50 ml</span><span class="chip">Extrait strength</span>';
 $("#pRev").textContent="("+p.rev+" reviews)";
 $("#pDesc").textContent=p.desc;
 $("#pStory").textContent=p.story;
 var oh="";for(var j=0;j<p.occ.length;j++){oh+='<span>'+p.occ[j]+'</span>';}
 $("#pOcc").innerHTML=oh;
 $("#pPrice").textContent=money(p.price);
 $("#nTop").textContent=p.top;$("#nHeart").textContent=p.heart;$("#nBase").textContent=p.base;
 $("#mLong").style.width=p.longPct+"%";$("#mProj").style.width=p.projPct+"%";
 $("#mLongTxt").textContent=p.longTxt;$("#mProjTxt").textContent=p.projTxt;
 $("#pWish").classList.toggle("on",!!wish[p.id]);
 galArr=['<img src="'+((window.BB_ASSETS||{}).heroNew||"")+'" alt="BuiltByThree fragrance collection" width="1086" height="1448">']; // FINAL PRODUCT QA: use one existing hero image and no product thumbnails
 $("#galMain").style.setProperty("--wash",p.wash);
 $("#galMain").innerHTML=galArr[0];
 $("#galThumbs").innerHTML="";
 /* pairs well with */
 var other=byId(PAIRS[p.id]);
 $("#fbtA").innerHTML=bottleSVG()+'<div><b>'+p.name+'</b><span>'+money(p.price)+'</span></div>';
 $("#fbtB").innerHTML=bottleSVG()+'<div><b>'+other.name+'</b><span>'+money(other.price)+'</span></div>';
 $("#fbtPrice").textContent=money(p.price+other.price);
 $("#fbtAdd").setAttribute("data-fbt",p.id+","+other.id);
 /* related */
 var rel=P.filter(function(x){return x.id!==p.id;}).slice(0,3);
 renderGrid($("#relGrid"),rel);
 /* recent */
 if(recent.indexOf(p.id)===-1){recent.unshift(p.id);}
 var rec=recent.filter(function(x){return x!==p.id;}).slice(0,3).map(byId);
 $("#recentWrap").style.display=rec.length?"block":"none";
 if(rec.length){renderGrid($("#recentGrid"),rec);}
 /* sticky */
 $("#sName").textContent=p.name;
 $("#sPrice").textContent=money(p.price);
 /* switch view */
 $("#viewHome").classList.remove("active");
 $("#viewProduct").classList.add("active");
 closeAll();
 window.scrollTo({top:0,behavior:"auto"});
 document.title=p.name+": BuiltByThree";
}
function goHome(target,filter){
 $("#viewProduct").classList.remove("active");
 $("#viewHome").classList.add("active");
 $("#stickyBar").classList.remove("show");
 document.title="BuiltByThree: Extrait de Parfum · Six Cities";
 closeAll();
 if(filter){applyFilter(filter);}
 if(target){setTimeout(function(){var el=document.getElementById(target);if(el)el.scrollIntoView({behavior:"smooth"});},60);}
 else{window.scrollTo({top:0,behavior:"auto"});}
}

/* ---------- sticky ATC ---------- */
var buyBox=$("#buyBox");
if("IntersectionObserver" in window){
 new IntersectionObserver(function(entries){
  var vis=$("#viewProduct").classList.contains("active");
  $("#stickyBar").classList.toggle("show",vis&&!entries[0].isIntersecting);
 },{rootMargin:"-80px 0px 0px 0px"}).observe(buyBox);
}

/* ---------- reveal on scroll ---------- */
var io=null;
if("IntersectionObserver" in window){
 io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:.12});
 $all(".reveal").forEach(function(el){io.observe(el);});
}else{$all(".reveal").forEach(function(el){el.classList.add("in");});}

/* ---------- search ---------- */
function renderSearch(q){
 q=(q||"").toLowerCase();var h="",n=0;
 for(var i=0;i<P.length;i++){
  var p=P[i],hay=(p.name+" "+p.plain+" "+p.cat+" "+p.top+" "+p.heart+" "+p.base+" "+p.occ.join(" ")).toLowerCase();
  if(!q||hay.indexOf(q)>-1){h+='<a href="#" data-open="'+p.id+'">'+p.name+': '+p.plain+'<span>'+money(p.price)+'</span></a>';n++;}
 }
 if(!n){h='<a href="#" data-goto="best">No match. View the full collection<span></span></a>';}
 $("#sResults").innerHTML=h;
}

/* ---------- events ---------- */
document.addEventListener("click",function(e){
 var t=e.target.closest("[data-add],[data-open],[data-wish],[data-goto],[data-home],[data-cat],[data-remove],[data-qplus],[data-qminus],[data-thumb],[data-fbt],[data-filter],[data-f1],[data-f2],[data-fback],.acc-btn");
 if(!t)return;
 if(t.hasAttribute("data-add")){e.preventDefault();addToCart(t.getAttribute("data-add"),1);return;}
 if(t.hasAttribute("data-fbt")){e.preventDefault();var ids=t.getAttribute("data-fbt").split(",");cart[ids[0]]=(cart[ids[0]]||0)+1;cart[ids[1]]=(cart[ids[1]]||0)+1;renderBadges();openDrawer("cart");toast("Pair added to cart");return;}
 if(t.hasAttribute("data-open")){e.preventDefault();openProduct(t.getAttribute("data-open"));return;}
 if(t.hasAttribute("data-wish")){
  e.preventDefault();var id=t.getAttribute("data-wish");wish[id]=!wish[id];
  $all('[data-wish="'+id+'"]').forEach(function(b){b.classList.toggle("on",wish[id]);});
  renderBadges();toast(wish[id]?byId(id).name+" saved to wishlist":byId(id).name+" removed from wishlist");
  if($("#drawer").classList.contains("on")&&drawerMode==="wish")renderDrawer();
  return;
 }
 if(t.hasAttribute("data-home")){e.preventDefault();goHome();return;}
 if(t.hasAttribute("data-cat")){e.preventDefault();var cf=t.getAttribute("data-cat");if($("#viewProduct").classList.contains("active")){goHome("best",cf);}else{applyFilter(cf);closeAll();var be=document.getElementById("best");if(be)be.scrollIntoView({behavior:"smooth"});}return;}
 if(t.hasAttribute("data-goto")){e.preventDefault();var g=t.getAttribute("data-goto");if($("#viewProduct").classList.contains("active")){goHome(g);}else{closeAll();var el=document.getElementById(g);if(el)el.scrollIntoView({behavior:"smooth"});}return;}
 if(t.hasAttribute("data-remove")){delete cart[t.getAttribute("data-remove")];renderBadges();renderDrawer();return;}
 if(t.hasAttribute("data-qplus")){var k1=t.getAttribute("data-qplus");cart[k1]++;renderBadges();renderDrawer();return;}
 if(t.hasAttribute("data-qminus")){var k2=t.getAttribute("data-qminus");cart[k2]--;if(cart[k2]<1)delete cart[k2];renderBadges();renderDrawer();return;}
 if(t.hasAttribute("data-thumb")){var ix=+t.getAttribute("data-thumb");$("#galMain").innerHTML=galArr[ix];$all(".thumb").forEach(function(x){x.classList.remove("on");});t.classList.add("on");return;}
 if(t.hasAttribute("data-filter")){applyFilter(t.getAttribute("data-filter"));return;}
 if(t.hasAttribute("data-f1")){fState={cat:t.getAttribute("data-f1"),pick:null};fRender();return;}
 if(t.hasAttribute("data-f2")){fState.pick=t.getAttribute("data-f2");fRender();return;}
 if(t.hasAttribute("data-fback")){fState=fState&&fState.pick?{cat:fState.cat,pick:null}:null;fRender();return;}
 if(t.classList.contains("acc-btn")){var acc=t.parentElement;acc.classList.toggle("open");t.setAttribute("aria-expanded",acc.classList.contains("open")?"true":"false");return;}
});

$("#qPlus").addEventListener("click",function(){qty++;$("#qOut").textContent=qty;});
$("#qMinus").addEventListener("click",function(){if(qty>1)qty--;$("#qOut").textContent=qty;});
$("#pAdd").addEventListener("click",function(){if(current)addToCart(current.id,qty);});
$("#sAdd").addEventListener("click",function(){if(current)addToCart(current.id,1);});
$("#pWish").addEventListener("click",function(){if(!current)return;var id=current.id;wish[id]=!wish[id];this.classList.toggle("on",wish[id]);$all('[data-wish="'+id+'"]').forEach(function(b){b.classList.toggle("on",wish[id]);});renderBadges();toast(wish[id]?current.name+" saved to wishlist":current.name+" removed from wishlist");});

$("#cartBtn").addEventListener("click",function(){openDrawer("cart");});
$("#wishBtn").addEventListener("click",function(){openDrawer("wish");});
$("#drClose").addEventListener("click",closeAll);
$("#scrim").addEventListener("click",closeAll);
$("#burgerBtn").addEventListener("click",function(){$("#mnav").classList.add("on");openScrim();});
$("#mnavClose").addEventListener("click",closeAll);
$("#searchBtn").addEventListener("click",function(){$("#search").classList.add("on");openScrim();renderSearch("");setTimeout(function(){$("#searchInput").focus();},80);});
$("#searchInput").addEventListener("input",function(){renderSearch(this.value);});
document.addEventListener("keydown",function(e){if(e.key==="Escape")closeAll();});

$("#checkoutBtn").addEventListener("click",function(){toast("Checkout opens at launch — join the list and we will tell you first ✦");if($("#viewProduct").classList.contains("active")){goHome("join");}else{closeAll();var el=document.getElementById("join");if(el)el.scrollIntoView({behavior:"smooth"});}});

/* nav overlay: transparent over the hero, solid once scrolled past it */
var heroSec=document.querySelector(".hero"),navBar=document.querySelector(".nav-overlay");
if(heroSec&&navBar){
 function checkNavOverlay(){
  var navH=navBar.offsetHeight;
  if(heroSec.getBoundingClientRect().bottom<=navH){navBar.classList.add("nav-solid");}
  else{navBar.classList.remove("nav-solid");}
 }
 checkNavOverlay();
 window.addEventListener("scroll",checkNavOverlay,{passive:true});
}

renderBadges();
})();
